import { graphql } from 'gatsby';
import React from 'react';
import { mapToPageModel } from '../mappers/page.mapper';
import { Page } from '../models';
import { Helmet } from 'react-helmet';
import favicon from '../images/favicon.ico';

const Disclaimer = ({ data: nodePage }) => {
  const pageData: Page = mapToPageModel(nodePage.nodePage);

  return (
    <section className="vl-region">
      <Helmet>
        <title>Disclaimer | Barometer samenleven</title>
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
      </Helmet>
      <div className="vl-layout">
        <h1 className="vl-title vl-title--h2">{pageData.title}</h1>
        <p
          className="vl-u-spacer-bottom  vl-typography"
          dangerouslySetInnerHTML={{ __html: pageData.body }}
        />
      </div>
    </section>
  );
};

export default Disclaimer;

export const query = graphql`
  query getNodePageDisclaimer {
    nodePage(id: { eq: "dc1582c9-a711-51c4-9129-11f132da937c" }) {
      body {
        processed
      }
      title
      id
    }
  }
`;
